import { render } from "./LogContentUpdateComponent.vue?vue&type=template&id=5e2bfc24&scoped=true"
import script from "./LogContentUpdateComponent.vue?vue&type=script&lang=js"
export * from "./LogContentUpdateComponent.vue?vue&type=script&lang=js"

import "./LogContentUpdateComponent.vue?vue&type=style&index=0&id=5e2bfc24&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2bfc24"]])

export default __exports__